import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=ecc2a490&scoped=true"
import script from "./CardList.vue?vue&type=script&lang=js"
export * from "./CardList.vue?vue&type=script&lang=js"
import style0 from "./CardList.vue?vue&type=style&index=0&id=ecc2a490&prod&lang=less&scoped=true"
import style1 from "./CardList.vue?vue&type=style&index=1&id=ecc2a490&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc2a490",
  null
  
)

export default component.exports